import { analytics, ChatEventName, EventCategory, useChatAuthAnalytics } from '../..';
import { useEffect } from 'react';
// track when transition is done from smart chat to twilio chat
export var useAuthTransitionTracking = function (client, loading) {
    var authViaSmartChat = useChatAuthAnalytics().authViaSmartChat;
    useEffect(function () {
        if (client && client.connectionState === 'connected' && !loading) {
            // this is the point where transition is done, so track it if coming from SmartChat.
            if (authViaSmartChat) {
                analytics({
                    event_name: ChatEventName.TRANSITIONED_FROM_SMART_TO_LENDI,
                    category: EventCategory.CHAT,
                });
            }
        }
    }, [client, loading]);
    return authViaSmartChat;
};
//# sourceMappingURL=index.js.map